<template>
  <div class="boxed-text-editor">
    <!-- テキストエディタ -->
    <template v-if="showTabContent">
      <div v-for="part in parts" :key="part.table_id">
        <tiny-mce-editor
          class="tinymceEditor"
          v-if="part.table_id === current.tableId"
          v-model="part.body"
          :isCodePart="false"
          :sectionId="sectionId"
          :partsContainerId="partsContainerId"
          :partId="part.id"
          :codePartNodeIndex="null"
          :extTypeName="extTypeName"
        />
      </div>
    </template>
    <!-- スタイル設定 -->
    <template v-if="showTabStyle">
      <div v-for="part in parts" :key="part.table_id">
        <div v-if="part.table_id === current.tableId">
          <!-- テキストのスタイル -->
          <edit-text-style
            v-model="part.styles"
            :sectionId="sectionId"
            :partsContainerId="partsContainerId"
            :partId="part.id"
          />
          <!-- ボックスのスタイル -->
          <edit-container-style
            :value="boxedTextStyles(part)"
            :sectionId="sectionId"
            :partsContainerId="partsContainerId"
            :partId="part.id"
            :partsContainerType="partsContainerType"
          />
        </div>
      </div>
    </template>
    <!-- レイアウト -->
    <edit-column-setting
      v-if="showTabSetting && singleRowPart"
      :sectionId="sectionId"
      :partsContainerId="partsContainerId"
      :partsContainerType="partsContainerType"
      :partsContainerStyles="partsContainerStyles"
      :spacerParts="spacerParts"
      :columnCount="columnCount"
      :flgSide="flgSide"
      @adjustCurrentTableId="$emit('adjustCurrentTableId', $event)"
    />
  </div>
</template>

<script>
import EditTextStyle from '@/components/Content/Palette/EditPartDesign/Layouts/StyleTab/TextStyle'
import EditColumnSetting from '@/components/Content/Palette/EditPartDesign/Layouts/ColumnSetting'
import EditContainerStyle from '@/components/Content/Palette/EditPartDesign/Editor/BoxedText/BoxedTextContainerStyle'
import TinyMceEditor from '@/components/Content/Palette/EditPartDesign/Editor/TinyMceEditor'

export default {
  props: [
    'current',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partsContainerStyles',
    'columnCount',
    'flgSide',
    'extTypeName',
  ],
  components: {
    EditTextStyle,
    EditColumnSetting,
    EditContainerStyle,
    TinyMceEditor,
  },
  computed: {
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    // 1行のみパーツであればtrue
    singleRowPart () {
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return null
      return partsContainer.type === 'BoxedText'
    },
    boxedTextStyles: function () {
      return function (part) {
        // 背景色・罫線のスタイル：画像カードの場合はパーツコンテナの値、それ以外はパーツに持っている値を使用
        // 内側余白のスタイル：パーツコンテナ種類に関わらず、パーツに持っている値を使用
        const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
        if (!partsContainer) return null
        let styles
        if (partsContainer.type === 'ImageCard') {
          styles = {
            'background': partsContainer.styles['background'],
            'border': partsContainer.styles['border'],
            'inner-padding': part.styles['inner-padding'],
          }
        } else {
          styles = { ...part.styles }
        }
        return styles
      }
    },
    spacerParts () {
      if (!this.parts) return null
      // テキストボックスパーツのみ 画像カードではスペーサーがないので不要
      if (this.partsContainerType !== 'BoxedText') return null
      return this.parts.filter(part => part.type === 'Spacer')
    },
  },
}
</script>
